import { Menu, X, LayoutDashboard, Users, Building2, ListTodo, Settings, UserPlus, BriefcaseBusiness } from "lucide-react";
import { useTranslate } from "ra-core";
import { Link, matchPath, useLocation } from "react-router";
import { useState } from "react";
import { useConfigurationContext } from "../root/ConfigurationContext";

const items = [
  { to: "/", key: "dashboard", icon: LayoutDashboard, label: "业务数据中枢" },
  { to: "/leads", key: "leads", icon: UserPlus, label: "线索" },
  { to: "/contacts", key: "contacts", icon: Users, label: "联系人" },
  { to: "/companies", key: "companies", icon: Building2, label: "客户 Account" },
  { to: "/deals", key: "deals", icon: BriefcaseBusiness, label: "商机" },
  { to: "/tasks", key: "tasks", icon: ListTodo, label: "Tasks" },
  { to: "/settings", key: "settings", icon: Settings, label: "Settings" },
];

export const MobileNavigation = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const translate = useTranslate();
  const { title, lightModeLogo, darkModeLogo } = useConfigurationContext();

  const activePath = (to: string) =>
    to === "/"
      ? location.pathname === "/"
      : !!matchPath({ path: to + "/*", end: false }, location.pathname) ||
        location.pathname === to;

  const labelFor = (item: (typeof items)[number]) => {
    const translated = (key: string, fallback: string, smartCount?: number) => {
      const value = translate(key, smartCount === undefined ? undefined : { smart_count: smartCount });
      return value === key ? fallback : value;
    };

    if (item.key === "dashboard") return translated("ra.page.dashboard", "Dashboard");
    if (item.key === "leads") return translated("resources.leads.name", "Leads", 2);
    if (item.key === "contacts") return translated("resources.contacts.name", "Contacts", 2);
    if (item.key === "companies") return translated("resources.companies.name", "Companies", 2);
    if (item.key === "deals") return translated("resources.deals.name", "Deals", 2);
    if (item.key === "tasks") return translated("resources.tasks.name", "Tasks", 2);
    return translated("crm.settings.title", "Settings");
  };

  return (
    <div className="orbitas-mobile-shell">
      <header className="orbitas-mobile-header">
        <button
          type="button"
          className="orbitas-mobile-menu-button"
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
        <Link to="/" className="orbitas-mobile-brand" onClick={() => setOpen(false)}>
          <img className="[.light_&]:hidden" src={darkModeLogo} alt="" />
          <img className="[.dark_&]:hidden" src={lightModeLogo} alt="" />
          <span>{title}</span>
        </Link>
        <span className="orbitas-mobile-header-caption">CRM</span>
      </header>

      {open && (
        <>
          <button
            type="button"
            className="orbitas-mobile-nav-backdrop"
            aria-label="Close navigation"
            onClick={() => setOpen(false)}
          />
          <nav className="orbitas-mobile-side-nav" aria-label={translate("crm.navigation.label")}>
            <div className="orbitas-mobile-nav-heading">工作区</div>
            {items.map((item) => {
              const Icon = item.icon;
              const active = activePath(item.to);
              return (
                <Link
                  key={item.key}
                  to={item.to}
                  onClick={() => setOpen(false)}
                  className={`orbitas-mobile-nav-link ${active ? "is-active" : ""}`}
                  aria-current={active ? "page" : undefined}
                >
                  <Icon size={20} aria-hidden="true" />
                  <span>{labelFor(item)}</span>
                </Link>
              );
            })}
          </nav>
        </>
      )}
    </div>
  );
};
